import {Component, Input, OnInit} from '@angular/core';
import {Information} from "../information";

@Component({
  selector: 'app-information-rackxtender',
  templateUrl: './information-rackxtender.component.html',
  styleUrls: ['./information-rackxtender.component.css']
})
export class InformationRackxtenderComponent implements OnInit {
  @Input() information: Information;

  constructor() {
    this.information = new Information();
  }

  ngOnInit(): void {
  }

}
